'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _Status = require('./Status.js');

var _Status2 = _interopRequireDefault(_Status);

var _availability = require('availability');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _FutureDeliveryHelper = require('./FutureDelivery/FutureDeliveryHelper');

var _FutureDeliveryHelper2 = _interopRequireDefault(_FutureDeliveryHelper);

var _Maybe = require('../Maybe');

var _Maybe2 = _interopRequireDefault(_Maybe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

var conjunct = _availability.iteratorFactory.conjunct,
    disjunct = _availability.iteratorFactory.disjunct,
    iter = _availability.iteratorFactory.iter;


function canMeetTime(delayMins, deliveryTime, _moment) {
    if (!deliveryTime) return true;

    var time = _moment();
    var diff = (deliveryTime - time) / 1000 / 60;

    if (diff < delayMins) return false;
    return true;
}

function isAvailable(restaurant, times, time) {
    if (!time) return true;

    var iterator = null;

    if (!times || !times.weekly && !times.exceptions) {
        iterator = iter(restaurant.openTimes)(time);
    } else {
        iterator = conjunct(times, restaurant.openTimes)(time);
    }

    if (!iterator.hasNext()) {
        return true;
    }

    var status = iterator.next();
    return status.status === 'available';
}

self.getOneLineAddress = function (restaurant) {
    var addressStr;

    if (restaurant.address.comment) {
        addressStr = restaurant.address.comment;
    } else if (restaurant.address.formatted) {
        addressStr = restaurant.address.formatted;
    } else {
        addressStr = restaurant.address.street + ' ' + restaurant.address.number + ', ' + restaurant.address.city;
    }

    return addressStr;
};

self.getStatus = function (restaurant, time) {
    return _Status2.default.getStatus(restaurant.openTimes, time);
};

self.getDeliveryStatus = function (restaurant, time) {
    if (self.isDeliveryInactive(restaurant)) {
        return { status: 'unavailable', until: Number.MAX_VALUE };
    }

    return _Status2.default.getStatus(restaurant.deliveryTimes, time);
};

self.isTakeoutInactive = function (restaurant) {
    var deliveryInfos = restaurant.deliveryInfos || [];

    for (var i = 0, l = deliveryInfos.length; i < l; i++) {
        if (deliveryInfos[i].type == 'takeout') return deliveryInfos[i].inactive || false;
    }

    return true;
};

self.getTakeoutCharge = function (restaurant) {
    var deliveryInfos = restaurant.deliveryInfos || [];

    for (var i = 0, l = deliveryInfos.length; i < l; i++) {
        if (deliveryInfos[i].type == 'takeout') return deliveryInfos[i].charge || 0;
    }

    return 0;
};

self.getTakeoutMinOrder = function (restaurant) {
    var deliveryInfos = restaurant.deliveryInfos || [];

    for (var i = 0, l = deliveryInfos.length; i < l; i++) {
        if (deliveryInfos[i].type == 'takeout') return deliveryInfos[i].minOrderPrice || 0;
    }

    return 0;
};

self.isDeliveryInactive = function (restaurant) {
    var deliveryInfos = restaurant.deliveryInfos;

    if (!deliveryInfos) {
        return false;
    }

    for (var i = 0, l = deliveryInfos.length; i < l; i++) {
        if (deliveryInfos[i].type !== 'takeout' && !deliveryInfos[i].inactive) return false;
    }

    return true;
};

self.getDeliveryInfoWithMinCharge = function (data, time) {
    var value = undefined;

    var deliveryInfos = data.deliveryInfos || [];

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];
        var exceptions = _lodash2.default.get(deliveryInfo, 'availability.exceptions', []);
        if (exceptions.find(function (ex) {
            return ex.available === false;
        })) continue;
        if (deliveryInfo.type != 'delivery') continue;
        if (deliveryInfo.inactive) continue;
        if (!isAvailable(data, deliveryInfo.availability, time)) continue;

        if (_lodash2.default.isUndefined(value) || (deliveryInfo.charge || 0) < value.charge) {
            value = deliveryInfo;
        }
    }

    if (_lodash2.default.isUndefined(value)) return undefined;
    return value;
};

self.getMinDeliveryChargePossible = function (data, time) {
    var info = self.getDeliveryInfoWithMinCharge(data, time);
    if (_lodash2.default.isUndefined(info)) return 0;
    if (_lodash2.default.isUndefined(info.charge)) return 0;
    return info.charge;
};

self.getMinMinPricedInfoContainingGecode = function (restaurant, geocode, time) {
    var best = undefined;

    var deliveryInfos = restaurant.deliveryInfos || [];

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];

        if (deliveryInfo.type != 'delivery') continue;
        if (deliveryInfo.inactive) continue;
        if (!isAvailable(restaurant, deliveryInfo.availability, time)) continue;
        if (best && best.minOrderPrice < deliveryInfo.minOrderPrice) continue;

        if (isInPolygon(deliveryInfo.area.polygon, geocode)) {
            best = deliveryInfo;
        }
    }

    return best;
};

self.getInactiveDeliveryAreas = function (restaurant, geocode) {
    var ret = [];

    var deliveryInfos = restaurant.deliveryInfos || [];

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];

        if (deliveryInfo.type != 'delivery') continue;
        if (deliveryInfo.inactive) continue;

        if (isInPolygon(deliveryInfo.area.polygon, geocode)) {
            ret.push(deliveryInfo);
        }
    }

    return ret;
};

self.getMaxDeliveryChargePossible = function (data, time) {
    var value = undefined;

    var deliveryInfos = data.deliveryInfos || [];

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];
        if (deliveryInfo.type != 'delivery') continue;
        if (deliveryInfo.inactive) continue;
        if (!isAvailable(data, deliveryInfo.availability, time)) continue;

        if (_lodash2.default.isUndefined(value) || (deliveryInfo.charge || 0) > value) {
            value = deliveryInfo.charge;
        }
    }

    if (_lodash2.default.isUndefined(value)) return 0;
    return value;
};

self.getMinMinOrderPossible = function (data, time) {
    var value = undefined;

    var deliveryInfos = data.deliveryInfos || [];

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];
        if (deliveryInfo.type != 'delivery') continue;
        if (deliveryInfo.inactive) continue;
        if (!isAvailable(data, deliveryInfo.availability, time)) continue;

        var minOrderPrice = deliveryInfo.minOrderPrice || 0;

        if (_lodash2.default.isUndefined(value) || minOrderPrice < value) {
            value = minOrderPrice;
        }
    }

    if (_lodash2.default.isUndefined(value)) return 0;
    return value;
};

self.getMaxMinOrderPossible = function (data, time) {
    var value = undefined;

    var deliveryInfos = data.deliveryInfos || [];

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];
        if (deliveryInfo.type != 'delivery') continue;
        if (deliveryInfo.inactive) continue;
        if (!isAvailable(data, deliveryInfo.availability, time)) continue;

        if (_lodash2.default.isUndefined(value) || deliveryInfo.minOrderPrice > value) {
            value = deliveryInfo.minOrderPrice;
        }
    }

    if (_lodash2.default.isUndefined(value)) return 0;
    return value;
};

self.getMinDelayMinsPossible = function (data, time) {
    var value = null;

    var deliveryInfos = data.deliveryInfos || [];

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];
        if (deliveryInfo.type != 'delivery') continue;
        if (deliveryInfo.inactive) continue;
        if (!isAvailable(data, deliveryInfo.availability, time)) continue;

        if (value == null || (deliveryInfo.delayMins || 0) < value) {
            value = deliveryInfo.delayMins || 0;
        }
    }

    return value || 0;
};

self.getMaxDelayMinsPossible = function (data, time) {
    var value = undefined;

    var deliveryInfos = data.deliveryInfos || [];

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];
        if (deliveryInfo.type != 'delivery') continue;
        if (deliveryInfo.inactive) continue;
        if (!isAvailable(data, deliveryInfo.availability, time)) continue;

        if (value == null || (deliveryInfo.delayMins || 0) > value) {
            value = deliveryInfo.delayMins;
        }
    }

    return value || 0;
};

self.isMultipleDeliveryArea = function (data) {
    var areas = {};

    var deliveryInfos = data.deliveryInfos || [];

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];

        if (deliveryInfo.type == 'delivery' && !deliveryInfo.inactive) {
            var key = (0, _stringify2.default)(deliveryInfo.area.title) + '_' + deliveryInfo.minOrderPrice + '_' + deliveryInfo.charge;
            areas[key] = 1;
        }
    }

    return _lodash2.default.keys(areas).length > 1;
};

//TODO: Use the one in GeoUtils instead
function isInPolygon(pol, point) {
    var i, j;
    var c = false;
    var nvert = pol.length;
    var lat = point.lat;
    var lng = point.lng;

    for (i = 0, j = nvert - 1; i < nvert; j = i++) {
        var vertex1 = pol[i];
        var vertex2 = pol[j];

        if (vertex1.lng < lng && vertex2.lng >= lng || vertex2.lng < lng && vertex1.lng >= lng) {
            if (vertex1.lat + (lng - vertex1.lng) / (vertex2.lng - vertex1.lng) * (vertex2.lat - vertex1.lat) < lat) {
                c = !c;
            }
        }
    }

    return c;
}

self.getCartDeliveryInfo = function (restaurant, cart) {
    var total = cart.subtotal;
    var deliveryTimestamp = _FutureDeliveryHelper2.default.getDeliveryTime(cart);
    var deliveryTime = deliveryTimestamp ? new _momentTimezone2.default(deliveryTimestamp) : new _momentTimezone2.default();
    var latLng = (0, _Maybe2.default)(cart.delivery).bind(function (d) {
        return d.address;
    }).bind(function (a) {
        return a.latLng;
    }).val();

    return this.getDeliveryInfo(total, restaurant, latLng, deliveryTime, cart.isFutureOrder ? deliveryTime : null);
};

self.getDeliveryInfo = function (total, restaurant, geocode, time, deliveryTime, _moment) {
    var deliveryInfos = restaurant.deliveryInfos || [];

    if (!geocode) {
        for (var i = 0; i < deliveryInfos.length; i++) {
            var deliveryInfo = deliveryInfos[i];
            if (deliveryInfo.type == 'takeout') {
                return deliveryInfo;
            }
        }

        return undefined;
    }

    var best = undefined;

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];

        if (deliveryInfo.type != 'delivery') continue;

        if (deliveryInfo.inactive) continue;

        if (!isAvailable(restaurant, deliveryInfo.availability, time)) continue;
        if (!canMeetTime(deliveryInfo.delayMins, deliveryTime, _moment || _momentTimezone2.default)) continue;
        if (total !== null && total < deliveryInfo.minOrderPrice) continue;
        if (best && (best.charge || 0) < deliveryInfo.charge) continue;
        if (isInPolygon(deliveryInfo.area.polygon, geocode)) {
            best = deliveryInfo;
        }
    }

    return best;
};

self.getAllDeliveryInfos = function (restaurant, geocode) {
    var ret = [];

    var deliveryInfos = restaurant.deliveryInfos || [];

    for (var i = 0; i < deliveryInfos.length; i++) {
        var deliveryInfo = deliveryInfos[i];

        if (deliveryInfo.type != 'delivery') continue;
        if (deliveryInfo.inactive) continue;

        if (isInPolygon(deliveryInfo.area.polygon, geocode)) {
            ret.push(deliveryInfo);
        }
    }

    return ret;
};

self.hasClubCoupons = function (params) {
    var restaurant = params.restaurant;

    return restaurant.id === 'betterburger-pt' || restaurant.id === '5670039316205915' /* couch potato */ || restaurant.id === '7952687233179291' /* lafromagette */;
};

function getAvailabilityStatus(availabilities) {
    var masterAvailabilities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [{}];
    var cal = arguments[2];

    var availabilitiesIterator = disjunct(availabilities);
    var getIter = conjunct.apply(undefined, [availabilitiesIterator].concat((0, _toConsumableArray3.default)(masterAvailabilities)));
    var it = getIter(cal.clone());

    if (!it.hasNext()) return null; // Should never happen!

    var status = it.next();
    var nextStatus = status;

    // Continue next until the status changes, or no more untils
    while (nextStatus.until && nextStatus.status === status.status) {
        status = nextStatus;
        nextStatus = it.next();
    }

    // If stopped since there were no more untils, that's the status, otherwise it was the last status
    // we received
    if (status.status === nextStatus.status) {
        status = nextStatus;
    }

    var ret = {};

    ret.available = status.status === 'available';

    if (status.until) {
        ret.until = status.until;
    }

    return ret;
}

self.getDeliveryOptions = function (params) {
    var restaurant = params.restaurant;
    var now = params.now || new _momentTimezone2.default().tz(restaurant.timezone);
    var cal = params.cal || now;

    var preorderTimeMins = function () {
        var time = params.preorderTime || _lodash2.default.get(restaurant, 'orders.asap.preOrderMins');
        return time || time === 0 ? time : 60;
    }();

    var hasUnavailableException = function hasUnavailableException(inf) {
        if (!inf) return false;
        if (!inf.availability) return false;
        if (!inf.availability.exceptions) return false;
        return !_lodash2.default.isEmpty(_lodash2.default.filter(inf.availability.exceptions, function (exc) {
            return !exc.available && !exc.start && !exc.end;
        }));
    };

    var premisesDeliveryInfos = _lodash2.default.filter(restaurant.deliveryInfos, function (inf) {
        return inf.type === 'premises' && !inf.inactive && !hasUnavailableException(inf);
    });
    var takeoutDeliveryInfos = _lodash2.default.filter(restaurant.deliveryInfos, function (inf) {
        return inf.type === 'takeout' && !inf.inactive && !hasUnavailableException(inf);
    });
    var deliveryDeliveryInfos = _lodash2.default.filter(restaurant.deliveryInfos, function (inf) {
        return inf.type === 'delivery' && !inf.inactive && !hasUnavailableException(inf);
    });

    var hasPremises = premisesDeliveryInfos.length > 0;
    var hasTakeout = takeoutDeliveryInfos.length > 0;
    var hasDelivery = deliveryDeliveryInfos.length > 0;

    var premises = null;
    var takeout = null;
    var delivery = null;

    var oloAvailability = _lodash2.default.get(restaurant, 'orders.availability', {});
    var openTimes = _lodash2.default.get(restaurant, 'openTimes', {});

    var getDispatchStatus = function getDispatchStatus(deliveryInfos, cal) {
        var dispatch = void 0;
        var availabilities = _lodash2.default.map(_lodash2.default.map(deliveryInfos, 'availability'), function (av) {
            return av || restaurant.openTimes || {};
        });

        dispatch = getAvailabilityStatus(availabilities, [oloAvailability, openTimes], cal);

        if (!dispatch.available && dispatch.until && (0, _momentTimezone2.default)(dispatch.until || 0).diff(cal, 'minutes', true) < preorderTimeMins) dispatch.preorder = true;

        return dispatch;
    };

    if (hasTakeout) {
        var delayMins = (0, _lodash2.default)(takeoutDeliveryInfos).map(function (di) {
            return di.delayMins;
        }).min();

        if (now < cal && cal.diff(now, 'm') < delayMins) {

            // Check what will be the status X minutes from now
            takeout = getDispatchStatus(takeoutDeliveryInfos, cal.clone().add(delayMins, 'm'));

            // If it'll be available, mark the takeout as unavailable until then
            if (takeout.available) {
                takeout.available = false;
                takeout.until = now.clone().add(delayMins, 'm').valueOf();
            }
        } else {
            takeout = getDispatchStatus(takeoutDeliveryInfos, cal);
        }
    }

    if (hasPremises) {
        var _delayMins = (0, _lodash2.default)(premisesDeliveryInfos).map(function (di) {
            return di.delayMins;
        }).min();

        if (now < cal && cal.diff(now, 'm') < _delayMins) {

            // Check what will be the status X minutes from now
            premises = getDispatchStatus(premisesDeliveryInfos, cal.clone().add(_delayMins, 'm'));

            // If it'll be available, mark the premises as unavailable until then
            if (premises.available) {
                premises.available = false;
                premises.until = now.clone().add(_delayMins, 'm').valueOf();
            }
        } else {
            premises = getDispatchStatus(premisesDeliveryInfos, cal);
        }
    }

    if (hasDelivery) {
        delivery = getDispatchStatus(deliveryDeliveryInfos, cal);
    }

    return { hasPremises: hasPremises, hasTakeout: hasTakeout, hasDelivery: hasDelivery, premises: premises, takeout: takeout, delivery: delivery };
};

self.getDeliveryAvailabilityIterator = function (organization) {
    return function getDeliveryAvailabilityIterator(cal) {
        if (cal.toDate().toString() === 'Invalid Date') return getUnavailableIterator();

        var availabilities = (0, _lodash2.default)(organization.deliveryInfos).filter(function (di) {
            return !di.inactive && di.type === 'delivery';
        }).map('availability').uniqWith(_lodash2.default.isEqual).value();

        if (availabilities.length === 0) return getUnavailableIterator();

        return conjunct(organization.openTimes, disjunct(availabilities))(cal);
    };
};

self.getPickupAvailabilityIterator = function (organization) {
    return function getPickupAvailabilityIterator(cal) {
        if (cal.toDate().toString() === 'Invalid Date') return getUnavailableIterator();

        var deliveryInfos = (0, _lodash2.default)(organization.deliveryInfos).filter(function (di) {
            return !di.inactive && di.type === 'takeout';
        }).value();

        if (_lodash2.default.isEmpty(deliveryInfos)) return getUnavailableIterator();

        var takeoutAvailability = _lodash2.default.map(deliveryInfos, 'availability')[0];

        return conjunct(takeoutAvailability, organization.openTimes)(cal);
    };
};

self.getOrganizationWithoutAvailabilityExceptions = function (organization) {
    var removeExceptions = function removeExceptions(availability) {
        return _lodash2.default.omit(availability, 'exceptions');
    };

    var openTimes = removeExceptions(organization.openTimes);

    var deliveryInfos = _lodash2.default.map(organization.deliveryInfos, function (di) {
        return _lodash2.default.assign((0, _extends3.default)({}, di), di.availability && {
            availability: removeExceptions(di.availability)
        });
    });

    return (0, _extends3.default)({}, organization, {
        openTimes: openTimes,
        deliveryInfos: deliveryInfos
    });
};

self.isUnavailableByException = function (availability, openTimes, time) {
    var iterWithoutExceptions = conjunct(_lodash2.default.omit(availability, 'exceptions'), _lodash2.default.omit(openTimes, 'exceptions'))(time);

    var next = getIterNext(iterWithoutExceptions);

    if (next.status === 'available') {
        var iterWithExceptions = conjunct(availability, openTimes)(time);

        next = getIterNext(iterWithExceptions);

        if (next.status === 'unavailable') {
            return {
                from: time,
                until: next.until && (0, _momentTimezone2.default)(next.until)
            };
        } else return false;
    } else return false;
};

self.getReservationAvailabilityIterator = function (restaurant, cal) {
    var openTimes = _lodash2.default.get(restaurant, 'openTimes', {});
    var reservationAvailability = _lodash2.default.get(restaurant, 'reservations.availability', {});
    return conjunct(openTimes, reservationAvailability)(cal);
};

function getIterNext(iterator) {
    if (iterator.hasNext()) return iterator.next();

    return { status: 'unavailable' };
}

function getUnavailableIterator() {
    return {
        hasNext: function hasNext() {
            return false;
        },
        next: function next() {
            return { status: 'unavailable' };
        }
    };
}

exports.default = self;